export const CREATE_ROUTE = 'CREATE_ROUTE';

const addNewRoute = (route) => ({
  type: CREATE_ROUTE,
  route,
  receivedAt: Date.now(),
});

export const createRoute = (route) => (dispatch) => dispatch(addNewRoute(route));
